/*
 *Leave Details
 */

import React from "react";
import { useState, useEffect, useRef } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Row,
  Button,
  Input,
  Select,
  DatePicker,
  Table,
  Space,
  Modal,
  Badge,
} from "antd";
import { Typography } from "antd";
import { toast, ToastContainer } from "react-toastify";
import {
  FilterOutlined,
  ReloadOutlined,
  DownloadOutlined,
  EditOutlined,
  DeleteOutlined,
  SafetyOutlined,
  CloudUploadOutlined,
  CloseOutlined,
  SearchOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import "../Dashboard/index.css";
import SimpleReactValidator from "simple-react-validator";
import { isEmpty } from "lodash";
import "../EmployeeManagement/index.css";
import "../LeaveAndPermissions/LeaveDetails.css";
import BreadcrumbComponent from "../../components/BreadCrumb";
import TextArea from "antd/es/input/TextArea";
import { useSelector, useDispatch } from "react-redux";
import * as leaveAction from "../../store/LeaveAndPermission/actions";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import moment from "moment/moment";
import api from "../../helpers";
import dayjs from "dayjs";

//bread crumb
const BCrumb = [{ to: "/", title: "Home" }, { title: "Leave Details" }];

const LeaveDetails = () => {
  const userType = localStorage.getItem("userType");
  const [searchLoading, setSearchLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const [filterEmployee, setFilterEmployee] = useState([]);
  const [filterEmployeeClear, setFilterEmployeeClear] = useState(false);

  const [employeeCodeList, setEmployeeCodeList] = useState("");
  const [employeePayloadId, setEmployeePayloadId] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const [employeeCodeClear, setEmployeeCodeClear] = useState(false);
  const [leaveId, setLeaveId] = useState();

  const [isConfirmVisible, setIsConfirmVisible] = useState(false);

  const specificDispatch = useDispatch();
  const dispatch = useDispatch();

  const simpleValidator = useRef(new SimpleReactValidator());
  const simpleApproveValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = React.useState();

  const [downloadLoader, setDownloadLoader] = useState(false);

  const [filteredData, setFilteredData] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    specificDispatch(
      leaveAction.loadLeaveDetails({
        limit: 10,
        page: 1,
        status: "BOTH",
      })
    );
    specificDispatch(leaveAction.loadLeaveDropdown());
  }, [specificDispatch]);

  //searchInput
  const [searchInput, setSearchInput] = useState("");
  const [searchValue, setSearchValue] = useState({
    limit: 10,
    page: 1,
    status: "BOTH",
  });
  //dropdown state from reducer
  const dropdownUpdate = useSelector((specificstate) => specificstate.Leave);
  const { dropDownList = {}, leaveList = {} } = dropdownUpdate;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(leaveList?.total); // get this from your API response

  useEffect(() => {
    if (leaveList) {
      setTotalCount(leaveList?.total); // total is total count of records in the backend
    }
  }, [leaveList]);

  //filter initial data
  const [filterData, setFilterData] = useState({
    employeeCode: "",
    fromDate: "",
    toDate: "",
  });

  const [departments, setDepartments] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);

  const [approvalModalStatus, setApprovalModalStatus] = useState([]);

  //modal initial data
  const [leaveDetails, setLeaveDetails] = useState({
    employeeCode: "",
    fromDate: "",
    toDate: "",
    reason: "",
    leaveDays: "",
  });

  //modal dropdown initial value
  const [department, setDepartment] = useState([]);
  const [leaveType, setLeaveType] = useState([]);
  const [leaveDuration, setLeaveDuration] = useState([]);

  const [designation, setDesignation] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  // const [fileNames, setFileNames] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [disabled, setDisabled] = useState(false);

  // delete modal
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteModalCancel = () => {
    setDeleteModalOpen(false);
  };

  // appove modal
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const handleApproveModalCancel = () => {
    setApproveModalOpen([]);
    setApproveModalOpen(false);
  };

  //modal input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeaveDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [remarks, setRemarks] = useState("");
  const handleApprovalChange = (e) => {
    const { name, value } = e.target;
    if (name === "remarks") {
      setRemarks(value);
    }
  };

  const [approvalModalOpen, setApprovalModalOpen] = useState(false);

  //filter date handler
  const handleFilterDateChange = (name, value) => {
    setFilterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDateChange = (field, date) => {
    const updatedDetails = { ...leaveDetails, [field]: date };

    const { fromDate, toDate } = updatedDetails;

    let days = "";
    if (fromDate && !toDate) {
      days = leaveDuration?.value === "FullDay" ? 1 : 0.5;
    } else if (fromDate && toDate) {
      const start = new Date(fromDate);
      const end = new Date(toDate);
      const diffInTime = end.getTime() - start.getTime();
      days =
        diffInTime >= 0 ? Math.floor(diffInTime / (1000 * 3600 * 24)) + 1 : 0;
    }

    updatedDetails.leaveDays = `${days} ${
      days === 0.5 || days === 1 ? "day" : "days"
    }`;
    setLeaveDetails(updatedDetails);
  };

  //delete
  const handleDelete = () => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
    const payload = {
      id: [leaveId],
      status:3
    };
    api
      .post(`auth/deleteleave`, payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(leaveAction.loadLeaveDetails(searchValue));
          toast.success("Leave details deleted successfully");
        } else {
          toast.warning(response?.data?.msg || "");
        }
        setDeleteModalOpen(false);
        return response.data;
      })
      .catch((err) => {
        const errorMsg =
     err?.response?.data?.error||err?.response?.data?.message ||
          "An error occurred while deleting the leave details";
        toast.error(errorMsg);
          setDeleteModalOpen(false);
        return Promise.reject(err);
      });
  };

  //update approval
  const handleApproveUpdate = () => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
    if (simpleApproveValidator.current.allValid()) {
      const payload = {
        leaveStatus: approvalModalStatus.value,
        remarks: remarks,
      }; //
      api
        .post(`/auth/approval/${leaveId}`, payload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            dispatch(leaveAction.loadLeaveDetails(searchValue));
            toast.success("Leave details approved successfully");
          } else {
            toast.warning(response?.data?.msg || "");
          }
          setApproveModalOpen(false);
          return response.data;
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message ||
            "An error occurred while approving the leave details";
          toast.error(errorMsg);
          return Promise.reject(err);
        });
    } else {
      simpleApproveValidator.current.showMessages(); // SHOW all error messages
      forceUpdate(1);
    }
  };

  //filter reset functionality
  const onReset = () => {
    setSearchInput("");
    setSearchValue({
      limit: 10,
      page: 1,
    });
    setResetLoading(true);
    setTimeout(() => {
      setFilterData({
        employeeCode: "",
        fromDate: "",
        toDate: "",
      });
      setFilterEmployee([]);
      setFilterEmployeeClear(true);
      setTimeout(() => {
        setFilterEmployeeClear(false);
      }, 0);
      setDepartments([]);
      setApprovalStatus([]);
      setLeaveTypes([]);
      setFilteredData([]);
      setResetLoading(false);
    }, 1000);
    dispatch(
      leaveAction.loadLeaveDetails({
        limit: 10,
        page: 1,
        status: "BOTH",
      })
    );
  };

  // modal clear data
  const clearModelData = () => {
    if (userType !== "admin") {
      setSlEmpId(loggedInEmployeeId);
      const defaultLabel = `${matchedEmployee.label}`;
      setEmployeeCodeList(defaultLabel);
      setDepartment({
        label: matchedEmployee.departmentName || "",
        value: matchedEmployee.departmentId || "",
      }); 

      setDesignation({
        label: matchedEmployee.designationName || "",
        value: matchedEmployee.designationId || "",
      });
      setEmployeePayloadId(matchedEmployee._id);
    } else {
      setDepartment(null);
      setDesignation(null);
      setEmployeeCodeList();
    }

    setLeaveDetails({
      employeeCode: "",
      fromDate: "",
      toDate: "",
      reason: "",
      leaveDays: "",
    });
    // setEmployeeCodeClear(true);
    // setTimeout(() => {
    //   setEmployeeCodeClear(false);
    // }, 0);
    // setEmployeeCodeList([]);

    // setDepartment([]);
    // setDesignation([]);
    setLeaveType([]);
    setLeaveDuration([]);
    //   setFileNames([]);
    setImagePreviews([]);
  };

  //submit functionality

  const handleInitialSubmit = () => {
    if (simpleValidator.current.allValid()) {
      setIsConfirmVisible(true); // Show confirmation modal
    } else {
      simpleValidator.current.showMessages(); // Show validation messages
      forceUpdate(1);
    }
  };

  const handleSubmit = () => {
    setDisabled(true); // Disable button
    setTimeout(() => setDisabled(false), 4000); // Re-enable after 4 sec

    const payload = {
      EmployeeId: employeePayloadId,
      leaveMode: leaveDuration.value,
      leaveType: leaveType.value,
      fromDate: leaveDetails.fromDate.format("YYYY-MM-DD"),
      toDate:
        leaveDuration.value === "FullDay"
          ? leaveDetails.toDate.format("YYYY-MM-DD")
          : leaveDetails.fromDate.format("YYYY-MM-DD"),
      noOfDays: leaveDetails.leaveDays,
      reason: leaveDetails.reason,
      status: 1,
      ...(!isEmpty(imagePreviews) && { attachment: imagePreviews[0].url }),
    };

    const endpoint = isEdit ? `/auth/updateleave/${leaveId}` : "/auth/apply";

    api
      .post(endpoint, payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(leaveAction.loadLeaveDetails(searchValue));
          toast.success(
            isEdit
              ? "Leave Details updated successfully"
              : "Leave Details added successfully"
          );
        } else {
          toast.warning(response?.data?.msg || "");
        }
        setIsModalVisible(false);
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.message ||
          `An error occurred while ${isEdit ? "updating" : "adding"} the leave`;
        toast.error(errorMsg, { containerId: "toast-1" });
      });
  };

  //edit functionality

  const handleEdit = (item) => {
    const leaveDetails = item.editData;
    setLeaveDetails({
      employeeCode: leaveDetails.employeecode?.employeeCode || "",
      toDate: leaveDetails.toDate ? dayjs(leaveDetails.toDate) : null,
      fromDate: leaveDetails.fromDate ? dayjs(leaveDetails.fromDate) : null,
      reason: leaveDetails.reason || "",
      leaveDays: leaveDetails.noOfDays || "",
    });

    setDepartment({
      label: leaveDetails.EmployeeId?.departmentId?.departmentName || "--",
      value: leaveDetails.EmployeeId?.departmentId?._id || "",
    });

    setDesignation({
      label: leaveDetails.EmployeeId?.designationId?.designationName || "--",
      value: leaveDetails.EmployeeId?.designationId?._id || "",
    });

    setLeaveType({
      label: leaveDetails.leaveType || "",
      value: leaveDetails.leaveType || "",
    });

    setLeaveDuration({
      label: leaveDetails.leaveMode || "",
      value: leaveDetails.leaveMode || "",
    });
    const defaultLabel = `${leaveDetails.EmployeeCode} - ${leaveDetails.EmployeeName}`;
    setEmployeeCodeList(defaultLabel);
    setEmployeePayloadId(leaveDetails?.EmployeeId?._id);
    setIsEdit(true);
    setIsModalVisible(true);

    if (leaveDetails.attachment) {
      //   setFileNames(leaveDetails.attachment);
      setImagePreviews([
        {
          url: leaveDetails.attachment,
          name: leaveDetails.attachment,
        },
      ]);
    } else {
      setImagePreviews([]);
    }
  };

  //filter functionality

  const handleFilter = (e) => {
    e.preventDefault();
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    let searchFilter = {};
    searchFilter.limit = pageSize;
    searchFilter.page = currentPage;
    searchFilter.status = "BOTH";
    if (filterData.fromDate)
      searchFilter.fromDate = filterData.fromDate.format("YYYY-MM-DD");
    if (filterData.toDate)
      searchFilter.toDate = filterData.toDate.format("YYYY-MM-DD");

    if (filterData.employeeCode)
      searchFilter.employeeCode = filterData.employeeCode;
    if (!isEmpty(departments)) searchFilter.departmentId = departments.value;
    if (!isEmpty(filterEmployee))
      searchFilter.employeeCode = filterEmployee?.value;
    if (!isEmpty(leaveTypes)) searchFilter.leaveType = leaveTypes.value;
    if (!isEmpty(approvalStatus))
      searchFilter.leaveStatus = approvalStatus.value;
    setSearchValue(searchFilter);

    console.log("Search Filter:", searchFilter);

    //dispatch

    if (!isEmpty(searchFilter)) {
      dispatch(leaveAction.loadLeaveDetails(searchFilter));
    } else {
      dispatch(
        leaveAction.loadLeaveDetails({ limit: 10, page: 1, status: "BOTH" })
      );
    }
  };

  //table colums
  const columns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sno - b.sno,
    },
    {
      title: <span className="poppins-txt">Action</span>,
      dataIndex: "action",
      width: 130,
      hidden: userType === "employee",
      render: (_, record) => (
        <Space style={{ gap: "8px" }}>
          {/* Edit Button */}
          <Button
            style={{
              background: "#34c38f",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              handleEdit(record);
              setLeaveId(record._id);
            }}
          >
            <EditOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>

          {/* Delete Button */}
          <Button
            style={{
              background: "#f46a6a",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              setDeleteModalOpen(true);
              setLeaveId(record._id);
            }}
          >
            <DeleteOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>

          {/* Approve Button */}
          <Button
            style={{
              background: "#f1b44c",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              setApprovalModalStatus([]);
              setRemarks("");
              setApproveModalOpen(true);
              setLeaveId(record._id);
            }}
          >
            <SafetyOutlined style={{ color: "#fff", fontSize: 18 }} />
          </Button>
        </Space>
      ),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Employee Code
        </span>
      ),
      dataIndex: "employeeCode",
      width: 160,
      hidden: userType === "employee",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeCode.localeCompare(b.employeeCode),
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      hidden: userType === "employee",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeName.localeCompare(b.employeeName),
    },
    {
      title: "Leave Type",
      dataIndex: "leaveType",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.leaveType.localeCompare(b.leaveType),
    },
    {
      title: "From Date",
      dataIndex: "fromDate",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.fromDate) - new Date(b.fromDate),
    },
    {
      title: "To Date",
      dataIndex: "toDate",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.toDate) - new Date(b.toDate),
    },
    {
      title: "Duration",
      dataIndex: "duration",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.duration - b.duration,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.reason.localeCompare(b.reason),
    },
    {
      title: "Approval Status",
      dataIndex: "approvalStatus",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.approvalStatus.localeCompare(b.approvalStatus),
      render: (text, record) => {
        let color =
          text === "Pending"
            ? "#f46a6a"
            : text === "Approved"
            ? "#34c38f"
            : "#f46a6a";

        return (
          <div className="flex items-center justify-center">
            <div className="flex items-center w-full">
              <Badge
                count={text}
                style={{
                  backgroundColor: color,
                  color: "#fff",
                  padding: "0 8px",
                  height: "24px",
                  lineHeight: "24px",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </div>
            <div>
              <EyeOutlined
                style={{
                  fontSize: "16px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  color: "blue",
                }}
                onClick={() => {
                  setLeaveId(record._id);
                  setApprovalModalOpen(true);
                }}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Approved By",
      dataIndex: "approvedBy",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.approvedBy.localeCompare(b.approvedBy),
    },
    {
      title: "Attachment",
      dataIndex: "attachment",
      className: "poppins-txt-lg",
      render: (text, record) => {
        // const hasAttachment = !!record.attachment;
        return record.attachment !== null && record.attachment ? (
          <a
            href={record.attachment}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            View
          </a>
        ) : (
          <span
            style={{
              color: "gray",
              textDecoration: "none",
              cursor: "not-allowed",
            }}
          >
            View
          </span>
        );
      },
    },
    {
      title: "Applied Date",
      dataIndex: "appliedDate",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.appliedDate) - new Date(b.appliedDate),
    },
  ];

  const columnApproval = [
    { title: "S.No", dataIndex: "sno", width: 70 },
    { title: "Approved By", dataIndex: "approvedBy" },
    { title: "Approved Date", dataIndex: "approvedDate" },
    { title: "Remarks", dataIndex: "remarks" },
  ];

  // search
  const handleSearch = () => {
    const payload = {
      search: searchInput,
      page: currentPage,
      limit: pageSize,
      status: "BOTH",
    };
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    dispatch(leaveAction.loadLeaveDetails(payload));
  };
  const tableData =
    leaveList && !isEmpty(leaveList.data)
      ? leaveList.data.map((data, index) => {
          return {
            _id: data._id,
            sno: index + 1,
            employeeCode: data.EmployeeCode || "--",
            employeeName: data.EmployeeName || "--",
            leaveType: data.leaveType || "--",
            fromDate: moment(data.fromDate).format("DD/MM/YYYY") || "--",
            toDate: moment.utc(data.toDate).format("DD/MM/YYYY") || "--",
            duration: data.noOfDays || "--",
            reason: data.reason || "",
            approvalStatus: data.leaveStatus || "--",
            approvedBy: data.approvedByUserName
              ? data.approvedByUserName
              : "--",
            attachment: data.attachment || "",
            appliedDate: data.createdOn
              ? moment(data.createdOn).format("DD/MM/YYYY")
              : "--",
            approvedByName: data.approvedByUserName
              ? data.approvedByUserName
              : "--",
            editData: data,
          };
        })
      : [];

  const selectedRecord =
    leaveList?.data?.find((item) => item._id === leaveId) || null;

  const tableApprovalData = selectedRecord
    ? [
        {
          _id: selectedRecord._id,
          sno: 1,
          approvedBy: selectedRecord.approvedByUserName || "--",
          approvedDate: selectedRecord.approvedOn
            ? moment(selectedRecord.approvedOn).format("DD/MM/YYYY")
            : "--",
          remarks: selectedRecord.remarks || "--",
        },
      ]
    : [];

  //download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = async () => {
    setDownloadLoader(true);

    let searchFilter = {};

    if (filterData.fromDate)
      searchFilter.fromDate = filterData.fromDate.format("YYYY-MM-DD");
    if (filterData.toDate)
      searchFilter.toDate = filterData.toDate.format("YYYY-MM-DD");

    if (filterData.employeeCode)
      searchFilter.employeeCode = filterData.employeeCode;
    if (!isEmpty(departments)) searchFilter.departmentId = departments;
    if (!isEmpty(filterEmployee))
      searchFilter.employeeCode = filterEmployee?.value;
    if (!isEmpty(leaveTypes)) searchFilter.leaveType = leaveTypes;
    if (!isEmpty(approvalStatus)) searchFilter.leaveStatus = approvalStatus;
    try {
      const res = await api.post("/auth/getleaverequest", searchFilter);
      const employees = res.data?.data || [];

      const mappedData = employees.map((data, index) => ({
        _id: data._id,
        sno: index + 1,
        employeeCode: data.EmployeeCode || "--",
        employeeName: data.EmployeeName || "--",
        leaveType: data.leaveType || "--",

        fromDate: data.fromDate
          ? moment(data.fromDate).format("DD/MM/YYYY")
          : "--",
        toDate: data.toDate ? moment(data.toDate).format("DD/MM/YYYY") : "--",
        duration: data.noOfDays || "--",
        reason: data.reason || "",
        approvalStatus: data.leaveStatus || "--",
        approvedBy: data.approvedByUserName ? data.approvedByUserName : "--",
        attachment: data.attachment || "",
        appliedDate: data.createdOn
          ? moment(data.createdOn).format("DD/MM/YYYY")
          : "--",
        approvedByName: data.approvedByUserName
          ? data.approvedByUserName
          : "--",
        editData: data,
      }));

      // Only include fields for CSV that you want:
      const headers = [
        "S.No",
        "Employee Code",
        "Employee Name",
        "Leave Type",
        "From Date",
        "To Date",
        "Duration",
        "Reason",
        "Approval Status",
        "Approved By",
        "Attachment",
        "Applied Date",
      ];

      const csvRows = mappedData.map((item) => [
        item.sno,
        item.employeeCode,
        item.employeeName,
        item.leaveType,
        item.fromDate,
        item.toDate,
        item.duration,
        item.reason,
        item.approvalStatus,
        item.approvedBy,
        item.attachment,
        item.appliedDate,
      ]);

      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      downloadFile({
        data: csvContent,
        fileName: "leave-details.csv",
        fileType: "text/csv",
      });
    } catch (error) {
      if (error) {
        setDownloadLoader(false);
      }
    } finally {
      setDownloadLoader(false);
    }
  };

  const handleEmployeeSelect = (selectedEmployee) => {
    //   setEmployeeCodeList(selectedEmployee);
    setFilterEmployee(selectedEmployee);

    if (selectedEmployee.departmentName) {
      setDepartment({
        label: selectedEmployee.departmentName,
        value: selectedEmployee._id,
      });
    }

    if (selectedEmployee.designationName) {
      setDesignation({
        label: selectedEmployee.designationName,
        value: selectedEmployee._id,
      });
    }
  };

  //pofile picture on change and api functionality
  const handleSinglePhoto = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    //   setFileNames(fileArray[0].name);

    // Upload
    const uploadPromises = fileArray.map((file) => {
      const formData = new FormData();
      formData.append("profilePicture", file);
      return api
        .post("/auth/employee/upload-image", formData)
        .then((res) => {
          if (res?.status === 200 && res?.data?.file) {
            toast.success("Image uploaded successfully!", {
              containerId: "toast-1",
            });
            return {
              url: res.data.file,
              name: res.data.file,
            };
          } else {
            const errorMsg = res?.data?.error?.message || "Upload failed.";
            toast.error(errorMsg, { containerId: "toast-1" });
            return null;
          }
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.error?.message || "Upload error occurred.";
          toast.error(errorMsg, { containerId: "toast-1" });
          return null;
        });
    });

    const uploadedImages = await Promise.all(uploadPromises);
    const validUploads = uploadedImages.filter(Boolean);
    setImagePreviews(validUploads);
  };

  //image preview handler
  const handleRemoveImage = (urlToRemove) => {
    setImagePreviews([]);
    // setFileNames("");
    URL.revokeObjectURL(urlToRemove);
  };

  const showModalOpen = () => {
    setIsEdit(false);
    setIsModalVisible(true);
    simpleValidator.current.hideMessages();
    simpleValidator.current.hideMessageFor("password");
    forceUpdate(3);
    clearModelData();
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const approvalStatusOptions = [
    { Typography: "Pending", value: "Pending" },
    { Typography: "Approved", value: "Approved" },
    { Typography: "Rejected", value: "Rejected" },
  ];

  const approvalOptions = [
    { Typography: "Approved", value: "Approved" },
    { Typography: "Rejected", value: "Rejected" },
  ];

  // sl cl options conditions
  const loginUser = JSON.parse(localStorage.getItem("user"));
  const loggedInEmployeeId = loginUser?.employeeId;

  const [slEmpId, setSlEmpId] = useState(loggedInEmployeeId);
  const matchedEmployee = dropDownList?.employeeOptions?.find(
    (emp) => emp._id === slEmpId
  );
  console.log(slEmpId, "slEmpId");
  const leaveOptions = [
    {
      Typography: "CL",
      value: "CL",
      disabled: matchedEmployee?.isCl === false, // disable if isCl is false
    },
    {
      Typography: "SL",
      value: "SL",
      disabled: matchedEmployee?.isSl === false, // disable if isSl is false
    },
    {
      Typography: "GL",
      value: "GL",
      disabled: false, // Always enabled
    },
  ];

  const leaveDurationOptions = [
    { Typography: "FullDay", value: "FullDay" },
    { Typography: "Morning Session", value: "Morning Session" },
    { Typography: "Afternoon Session", value: "Afternoon Session" },
  ];

  // const handleRemoveImage = (index) => {
  //   setImagePreviews((prev) => prev.filter((_, i) => i !== index));
  // };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  // const [loading, setLoading] = useState(false);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    // setLoading(true);
    setTimeout(() => {
      // setLoading(false);
    }, 1500);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fuseOptions = {
    keys: ["employeeCode", "label"],
  };

  const handleEmployeeCodeClear = () => {
    setEmployeeCodeList([]);
    setFilterEmployee([]);
    clearModelData();

    setEmployeeCodeClear(true);
    setTimeout(() => {
      setEmployeeCodeClear(false);
    }, 0);
  };

  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>Leave Details | Mequals</title>
        </MetaTags>
      </div>

      <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="Leave Details" items={BCrumb} />
        </Col>

        <Col>
          <Button
            className="custom-btn mt-2"
            type="primary"
            size="medium"
            onClick={() => showModalOpen()}
          >
            Apply Leave
          </Button>
        </Col>
      </Row>
      <Modal
        open={isModalVisible}
        onCancel={handleModalClose}
        title={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "20px",
            }}
            className="poppins-txt"
          >
            <span>{isEdit ? "Edit Leave" : "Apply Leave"}</span>
          </div>
        }
        // title="Apply Leave"
        className="poppins-txt custom-active-modal"
        centered
        maskClosable={false}
        footer={null}
        width="70vw"
        maxWidth="1200px"
        style={{
          padding: 0,
          marginLeft: windowDimensions.width > 992 ? "220px" : "0",
        }}
      >
        <div className="custom-modal-content">
          <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}> 
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Employee Code
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>

              <ReactSearchAutocomplete
                name="employeeCodeList"
                inputSearchString={employeeCodeList}
                key={employeeCodeClear}
                items={
                  showDropdown && dropDownList.employeeOptions
                    ? dropDownList.employeeOptions
                    : []
                }
                value={employeeCodeList}
                type="autoComplete"
                resultStringKeyName="label"
                showIcon={false}
                onChange={(e) => {
                  if (userType !== "employee")
                    setEmployeeCodeList(e.target.value);
                  setSlEmpId(e.target.value);
                }}
                onFocus={() => {
                  if (userType !== "employee") setShowDropdown(true);
                }}
                onSelect={(item) => {
                  if (userType !== "employee") {
                    setEmployeeCodeList(item.label);
                    setEmployeePayloadId(item._id);
                    setShowDropdown(false);
                    handleEmployeeSelect(item);
                    setSlEmpId(item._id);
                  }
                }}
                onSearch={(string, results) => {
                  if (userType !== "employee") setShowDropdown(true);
                }}
                onClear={() => {
                  if (userType !== "employee") handleEmployeeCodeClear();
                }}
                showClear={userType !== "employee"}
                placeholder="Enter Employee code"
                fuseOptions={fuseOptions}
                className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
                styling={{
                  height: "30px",
                  border: "1px solid #ced4da",
                  borderRadius: "4px",
                  backgroundColor:
                    userType === "employee" ? "#f5f5f5" : "white",
                  pointerEvents: userType === "employee" ? "none" : "auto",
                  opacity: userType === "employee" ? 0.6 : 1,
                  boxShadow: "none",
                  textAlign: "end",
                  hoverBackgroundColor: "lightgray",
                  color: "black",
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  iconColor: "green",
                  clearIconMargin: "3px 8px 0 0",
                  zIndex: 10,
                }}
              />

              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "employeeCode",
                  employeeCodeList,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">Department</Typography>
              </div>
              <Select
                placeholder="Select department"
                allowClear
                className="custom-select"
                name="department"
                disabled={true}
                value={department}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setDepartment({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setDepartment({ label: "", value: "" });
                  }
                }}
                options={
                  !isEmpty(dropDownList) ? dropDownList.departmentOptions : []
                }
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">Designation</Typography>
              </div>
              <Select
                placeholder="Select designation"
                allowClear
                className="custom-select"
                name="designation"
                value={designation}
                disabled={true}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setDesignation({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setDesignation({ label: "", value: "" });
                  }
                }}
                options={
                  !isEmpty(dropDownList) ? dropDownList.designationOptions : []
                }
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Leave Type
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <Select
                placeholder="Select leave type"
                allowClear
                className="custom-select"
                name="leaveType"
                value={leaveType}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setLeaveType({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setLeaveType({ label: "", value: "" });
                  }
                }}
                options={leaveOptions}
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "leaveType",
                  leaveType,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Leave Duration
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <Select
                placeholder="Select leave type"
                allowClear
                className="custom-select"
                name="leaveDuration"
                value={leaveDuration}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setLeaveDuration({ label: options.label, value: value });
                  } else {
                    // cleared selection
                    setLeaveDuration({ label: "", value: "" });
                  }
                  setLeaveDetails((prevData) => ({
                    ...prevData,
                    fromDate: "",
                    toDate: "",
                    leaveDays: "",
                  }));
                }}
                options={leaveDurationOptions}
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "leaveDuration",
                  leaveDuration,
                  "required"
                )}
              </span>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div>
                <div className="mb-2">
                  <Typography className="poppins-txt">
                    Leave From Date
                    <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                  </Typography>
                </div>
                <DatePicker
                  className="custom-select py-2"
                  name="fromDate"
                  format="DD/MM/YYYY"
                  value={leaveDetails.fromDate}
                  onChange={(date) => handleDateChange("fromDate", date)}
                  minDate={dayjs().add(1, "day")} // Any date after today
                />
                <span
                  style={{
                    color: "#ef3022",
                    fontSize: "11px",
                    marginTop: "8px",
                    fontFamily: "poppins",
                    display: "block",
                  }}
                >
                  {simpleValidator.current.message(
                    "fromDate",
                    leaveDetails.fromDate,
                    "required"
                  )}
                </span>
              </div>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div>
                <div className="mb-2">
                  <Typography className="poppins-txt">Leave To Date</Typography>
                </div>
                <DatePicker
                  className="custom-select py-2"
                  name="toDate"
                  format="DD/MM/YYYY"
                  value={
                    leaveDuration.value === "FullDay"
                      ? leaveDetails.toDate
                      : leaveDetails.fromDate
                  }
                  onChange={(date) => handleDateChange("toDate", date)}
                  disabled={leaveDuration.value !== "FullDay"}
                  minDate={leaveDetails.fromDate || null}
                  maxDate={
                    leaveDetails.fromDate
                      ? dayjs(leaveDetails.fromDate).add(1, "day") // Only up to 2 days
                      : null
                  }
                />
              </div>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">Duration</Typography>
              </div>
              <Input
                value={leaveDetails.leaveDays || ""}
                readOnly
                className="custom-select py-2"
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <Typography className="poppins-txt">Attachment File</Typography>
              <div style={{ position: "relative", marginTop: 8 }}>
                <Input
                  value={imagePreviews.map((img) => img.name).join(", ")}
                  accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain"
                  placeholder="Choose File"
                  readOnly
                  // Clicking the input triggers the hidden file input click
                  onClick={() =>
                    document.getElementById("gallery-file-upload").click()
                  }
                  // Prefix with a filled cloud upload icon, styled larger with margin (gap)
                  prefix={
                    <CloudUploadOutlined
                      style={{
                        color: "blue",
                        fontSize: 24,
                        marginRight: 12, // Increase the gap between icon and placeholder
                      }}
                    />
                  }
                  style={{
                    cursor: "pointer",
                    paddingLeft: 8, // Adds a little more padding on the left for the text
                  }}
                />

                {/* Hidden file input overlay */}
                <input
                  id="gallery-file-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleSinglePhoto} // <- change handler name too
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                />
              </div>

              {/* Image previews */}
              {imagePreviews.length > 0 && (
                <div style={{ marginTop: 16 }}>
                  {imagePreviews.map((img, imgsIndex) => (
                    <div
                      key={imgsIndex}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography
                        style={{
                          textDecoration: "underline",
                          color: "blue",
                          "&:hover": { color: "darkblue" },
                          fontSize: "14px",
                        }}
                        onClick={() => window.open(img.url, "_blank")}
                      >
                        View
                      </Typography>

                      <CloseOutlined
                        onClick={() => handleRemoveImage(imgsIndex)}
                        style={{
                          fontSize: 16,
                          color: "#ef3022",
                          padding: "2px",
                          marginLeft: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </Col>

            <Col xs={24} sm={24} md={17} lg={17} xl={17}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Reason
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <TextArea
                placeholder="Enter Reason"
                rows={3}
                name="reason"
                value={leaveDetails.reason}
                onChange={(e) => handleChange(e)}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "reason",
                  leaveDetails.reason,
                  "required"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "30px" }}
            >
              <div>
                <div className="mb-2">
                  <Typography className="poppins-txt">SL :</Typography>
                </div>
              </div>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "30px" }}
            >
              <div>
                <div className="mb-2">
                  <Typography className="poppins-txt">CL :</Typography>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* Custom footer with cancel and confirm buttons */}
        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            onClick={handleModalClose}
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={disabled}
            className="custom-btn"
            style={{
              backgroundColor: "#34c38f",
              color: "#fff",
              border: "none",
            }}
            // onClick={() => setIsConfirmVisible(true)}
            onClick={handleInitialSubmit}
          >
            {isEdit ? "Update" : "Submit"}
          </Button>
        </div>
        <ToastContainer
          containerId="toast-1"
          position="top-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          style={{
            fontSize: "12px",
          }}
          pauseOnHover
          theme="dark"
        />
      </Modal>

      <Modal
        open={isConfirmVisible}
        onCancel={() => setIsConfirmVisible(false)}
        title={"Confirmation"}
        // title="Apply Leave"
        className="poppins-txt custom-active-modal"
        centered
        maskClosable={false}
        width={450}
        footer={null}
        maxWidth="1200px"
        style={{
          padding: 0,
          marginLeft: windowDimensions.width > 992 ? "220px" : "0",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <p className="poppins-txt" style={{ padding: "15px" }}>
            Are you sure Do you want to {isEdit ? "update" : "submit"} this
            request?
          </p>

          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px 0px 0px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
              onClick={() => setIsConfirmVisible(false)}
            >
              Close
            </Button>
            <Button
              disabled={disabled}
              className="custom-btn"
              onClick={() => {
                handleSubmit();
                setIsConfirmVisible(false);
              }}
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          ></div>
        </div>
      </Modal>

      <Modal
        title={"Confirmation"}
        open={deleteModalOpen}
        onCancel={handleDeleteModalCancel}
        cancelText="Cancel"
        className="poppins-txt custom-active-modal"
        width={450}
        footer={null}
        // style={{ padding: 0 }}
        centered
      >
        <div className="custom-modal-content">
          <p>Are you sure you want to delete this leave details?</p>
        </div>

        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
            onClick={() => handleDeleteModalCancel()}
          >
            Close
          </Button>
          <Button
            disabled={disabled}
            className="custom-btn"
            onClick={() => handleDelete()}
            style={{
              backgroundColor: "#34c38f",
              color: "#fff",
              border: "none",
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>

      <Modal
        title={"Confirmation"}
        open={approveModalOpen}
        onCancel={handleApproveModalCancel}
        cancelText="Cancel"
        className="poppins-txt custom-active-modal"
        width={500}
        footer={null}
        centered
        styles={{
          body: {
            minHeight: "100px",
          },
        }}
      >
        <div className="custom-modal-content">
          <Col xs={24}>
            <div className="mb-2">
              <Typography className="poppins-txt">
                Approval Status
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
            </div>
            <Select
              placeholder="Select approval status"
              allowClear
              className="custom-select"
              name="approvalModalStatus"
              value={approvalModalStatus}
              onChange={(value, options) => {
                if (options) {
                  // normal selection
                  setApprovalModalStatus({
                    label: options.label,
                    value: value,
                  });
                } else {
                  // cleared selection
                  setApprovalModalStatus({ label: "", value: "" });
                }
              }}
              options={approvalOptions}
              autoComplete="off"
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
            />
            <span
              style={{
                color: "#ef3022",
                fontSize: "11px",
                marginTop: "8px",
                fontFamily: "poppins",
                display: "block",
              }}
            >
              {simpleApproveValidator.current.message(
                "approvalModalStatus",
                approvalModalStatus,
                "required"
              )}
            </span>
          </Col>
          <Col xs={24} style={{ marginTop: "5px" }}>
            <div className="mb-2">
              <Typography className="poppins-txt">Remarks</Typography>
            </div>
            <TextArea
              placeholder="Enter Remarks"
              rows={3}
              name="remarks"
              value={remarks}
              onChange={(e) => handleApprovalChange(e)}
            />
          </Col>
        </div>

        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
            onClick={() => handleApproveModalCancel()}
          >
            Close
          </Button>
          <Button
            disabled={disabled}
            className="custom-btn"
            onClick={() => handleApproveUpdate()}
            style={{
              backgroundColor: "#34c38f",
              color: "#fff",
              border: "none",
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>

      <div
        style={{
          background: "#ffffff",
          margin: "4px 8px 4px 8px", // top, right, bottom, left
          padding: "16px",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
          {userType === "admin" && (
            <>
              {" "}
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">Employee Code</Typography>
                </div>

                <ReactSearchAutocomplete
                  name="filterEmployee"
                  key={filterEmployeeClear}
                  items={
                    dropDownList.employeeOptions
                      ? dropDownList.employeeOptions
                      : []
                  }
                  value={filterEmployee}
                  type="autoComplete"
                  resultStringKeyName="label"
                  showIcon={false}
                  onChange={(e) => {
                    setFilterEmployee(e.target.value);
                  }}
                  onFocus={() => setShowDropdown(true)}
                  onSelect={(item) => {
                    setFilterEmployee(item);
                  }}
                  //   onSelect={handleEmployeeSelect}
                  onClear={() => setFilterEmployee([])}
                  showClear
                  placeholder="Enter Employee code"
                  fuseOptions={fuseOptions} // Search on both fields
                  className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
                  styling={{
                    height: "30px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    backgroundColor: "white",
                    boxShadow: "none",
                    textAlign: "end",
                    hoverBackgroundColor: "lightgray",
                    color: "black",
                    // marginBottom: "-3px",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    iconColor: "green",
                    clearIconMargin: "3px 8px 0 0",
                    zIndex: 10,
                  }}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">Department</Typography>
                </div>
                <Select
                  placeholder="Select department"
                  allowClear
                  className="custom-select"
                  name="departments"
                  value={departments}
                  onChange={(value, options) => {
                    if (options) {
                      // normal selection
                      setDepartments({
                        label: options.label,
                        value: value,
                      });
                    } else {
                      // cleared selection
                      setDepartments({ label: "", value: "" });
                    }
                  }}
                  // onChange={(value, options) =>
                  //   setDepartments({ label: options.label, value: value })
                  // }
                  options={
                    !isEmpty(dropDownList) ? dropDownList.departmentOptions : []
                  }
                  autoComplete="off"
                  dropdownRender={(menu) => (
                    <h1 className="option-text-font">{menu}</h1>
                  )}
                />
              </Col>
            </>
          )}

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">Leave From Date</Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="fromDate"
                value={filterData.fromDate}
                onChange={(date) => handleFilterDateChange("fromDate", date)}
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">Leave To Date</Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="toDate"
                value={filterData.toDate}
                onChange={(date) => handleFilterDateChange("toDate", date)}
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Leave Type</Typography>
            </div>
            <Select
              placeholder="Select leave type"
              allowClear
              className="custom-select"
              name="leaveTypes"
              value={leaveTypes}
              // onChange={(value, options) =>
              //   setLeaveTypes({ label: options.label, value: value })
              // }
              onChange={(value, options) => {
                if (options) {
                  // normal selection
                  setLeaveTypes({
                    label: options.label,
                    value: value,
                  });
                } else {
                  // cleared selection
                  setLeaveTypes({ label: "", value: "" });
                }
              }}
              options={leaveOptions}
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
              autoComplete="off"
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Approval Status</Typography>
            </div>
            <Select
              placeholder="Select approval status"
              allowClear
              className="custom-select"
              name="approvalStatus"
              value={approvalStatus}
              // onChange={(value, options) =>
              //   setApprovalStatus({ label: options.label, value: value })
              // }
              onChange={(value, options) => {
                if (options) {
                  // normal selection
                  setApprovalStatus({
                    label: options.label,
                    value: value,
                  });
                } else {
                  // cleared selection
                  setApprovalStatus({ label: "", value: "" });
                }
              }}
              options={approvalStatusOptions}
              autoComplete="off"
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
            />
          </Col>
        </Row>

        <Row
          justify="end"
          style={{ marginTop: userType === "admin" ? "8px" : "14px" }}
        >
          <Col>
            <Button
              className="custom-btn"
              icon={<ReloadOutlined style={{ fontSize: "16px" }} />}
              size="middle"
              onClick={onReset}
              loading={resetLoading}
              danger
              style={{ marginRight: "12px" }}
            >
              Reset
            </Button>
            <Button
              className="custom-btn"
              type="primary"
              size="middle"
              icon={<FilterOutlined style={{ fontSize: "18px" }} />}
              htmlType="submit"
              onClick={handleFilter}
              loading={searchLoading}
            >
              Apply Filter
            </Button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          background: "#ffffff",
          margin: "20px 8px 15px 8px", // top, right, bottom, left
          padding: "16px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            {userType === "admin" ? (
              <>
                <Input
                  placeholder="Search..."
                  allowClear
                  style={{ width: 250, fontFamily: "Poppins" }}
                  name="searchInput"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  type="text"
                  autoComplete="off"
                />
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  style={{ marginLeft: 8 }}
                  onClick={handleSearch}
                />
              </>
            ) : (
              // Empty div to maintain spacing
              <div style={{ width: 250 }}></div>
            )}
          </Col>

          <Col>
            <Button
              className="custom-btn"
              size="medium"
              type="primary"
              icon={<DownloadOutlined />}
              loading={downloadLoader}
              onClick={exportToCsv}
            >
              Download
            </Button>
          </Col>
        </Row>

        <Table
          columns={columns}
          loading={searchLoading}
          dataSource={filteredData.length ? filteredData : tableData}
          // dataSource={filteredData}
          className="poppins-txt"
          rowKey={(record) => record._id}
          rowClassName={"text-[12px]"}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalCount, // make sure you provide total count from API
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "30"],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          }}
          sortDirections={["ascend", "descend"]}
          showSorterTooltip={"sorter-icon"}
          scroll={{
            x: 765,
          }}
          onChange={(pagination, filters, sorter) => {
            const { current, pageSize } = pagination;
            setCurrentPage(current); // you can manage currentPage and pageSize in your component state if needed
            setPageSize(pageSize);
            const updatedParams = {
              ...searchValue,
              page: current,
              limit: pageSize,
              status: "BOTH",
            };

            setSearchValue(updatedParams);
            specificDispatch(leaveAction.loadLeaveDetails(updatedParams));
          }}
        />
      </div>

      <Modal
        title={"Approval Status"}
        open={approvalModalOpen}
        onCancel={() => setApprovalModalOpen(false)}
        cancelText="Cancel"
        className="poppins-txt custom-active-modal"
        footer={null}
        maskClosable={false}
        // style={{ top: 90, left: 100 }}
        width={
          windowDimensions.width > 992
            ? 700
            : windowDimensions.width > 600
            ? 600
            : windowDimensions.width - 40
        }
        style={{
          top: 90,
          padding: 0,
          ...(windowDimensions.width > 1189
            ? { marginLeft: "400px" }
            : windowDimensions.width > 992
            ? { marginLeft: "300px" }
            : windowDimensions.width > 600
            ? { margin: "0 auto" }
            : windowDimensions.width > 40
            ? { margin: "0 auto" }
            : { marginLeft: "0" }),
        }}
        // style={{ padding: 0 }}
      >
        <div className="custom-modal-content">
          <Table
            columns={columnApproval}
            dataSource={tableApprovalData}
            className="poppins-txt mb-2"
            rowKey={(record) => record._id}
            rowClassName={"text-[12px]"}
            size="small"
            pagination={false}
          />
        </div>

        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
            onClick={() => setApprovalModalOpen(false)}
          >
            Close
          </Button>
        </div>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

export default LeaveDetails;
